// extracted by mini-css-extract-plugin
module.exports = {"sample-survey-tag":"Pagination_sample-survey-tag__2og62"};